import * as React from 'react';
import { useContext, useEffect } from 'react';

import ModalDefault from './ModalDefault';
import Button from '../button/Button';

import { ModalContext } from '../../provider/ModalProvider';

import { StyledModalWrapper, StyledModalTitle, StyledModalUtil } from '../../styles/common';

function ModalCheck() {
  const { modal_check } = useContext(ModalContext);
  return (
    <>
      <ModalDefault visible={modal_check.data.visible} onClose={() => modal_check.closeModalCheck()}>
        <StyledModalWrapper>
          <StyledModalTitle dangerouslySetInnerHTML={{ __html: modal_check.data.title }}></StyledModalTitle>
          <StyledModalUtil>
            <Button
              color='green'
              onClick={() => modal_check.closeModalCheck()}
              sx={{ width: 1, height: 1, fontSize: '1.2rem' }}
            >
              확인
            </Button>
          </StyledModalUtil>
        </StyledModalWrapper>
      </ModalDefault>
    </>
  );
}

export default ModalCheck;
